import { BodyText, Card, CardContent } from '@cint/wonderment';
import clsx from 'clsx';
import { ReactNode } from 'react';

export interface TrackingMethodCardProps {
  icon: ReactNode;
  title: string;
  badge?: ReactNode;
  subtitle?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  /**
   * Where the actions sit relative to the description: on the same row and
   * pushed right ('inline'), or on their own row below it, aligned left.
   */
  actionsPlacement?: 'inline' | 'below';
  children?: ReactNode;
  className?: string;
}

export const TrackingMethodCard = ({
  icon,
  title,
  badge,
  subtitle,
  description,
  actions,
  actionsPlacement = 'inline',
  children,
  className,
}: TrackingMethodCardProps) => (
  <Card variant="subtle" className={clsx('ds-bg-subtle-tint', className)}>
    <CardContent>
      <div className="flex items-center justify-between gap-6">
        <div className="flex gap-3">
          <div className="ds-bg-accent flex h-10 w-10 shrink-0 items-center justify-center rounded-full">
            {icon}
          </div>
          <div>
            <div className="flex items-center gap-2">
              <BodyText fontWeight="bold" className="ds-text-secondary">
                {title}
              </BodyText>
              {badge}
            </div>
            {subtitle && (
              <BodyText className="ds-text-secondary" size="sm">
                {subtitle}
              </BodyText>
            )}
          </div>
        </div>
      </div>
      <div
        className={clsx(
          'gap-2',
          actionsPlacement === 'below'
            ? 'flex flex-col items-start'
            : 'flex items-center justify-between'
        )}
      >
        <BodyText className="ds-text-secondary mt-3" size="sm">
          {description}
        </BodyText>
        {actions && (
          <div className="flex shrink-0 items-center gap-2">{actions}</div>
        )}
      </div>
      {children && <div className="mt-7">{children}</div>}
    </CardContent>
  </Card>
);
